import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Directive({
    selector: '[modal-toggle]',
    standalone: false
})
export class ModalToggleDirective {

    @Input('modal-toggle') modalId: string;

    constructor(
        private toastr: ToastrService,
        private el: ElementRef
    ) {
    }

    @HostListener('click')
    openModal() {
        if (this.modalId) {
            try {
                document.getElementById(this.modalId).classList.toggle('opened');
            } catch (e) {
                console.error('modal-toggle: #' + this.modalId, e);
                this.toastr.error('Algo inesperado ocorreu');
            }
        } else {
            const parent = this.findParentModal(this.el.nativeElement);

            if (parent) {
                parent.classList.remove('opened');
            } else {
                console.error('modal-toggle: não foi encontrado um modal parent', this.el.nativeElement);
                this.toastr.error('Algo inesperado ocorreu');
            }
        }
    }

    private findParentModal(element: HTMLElement): HTMLElement | null {
        if (!element) {
            return null;
        }

        if (element.classList.contains('ui-modal')) {
            return element.parentElement;
        }

        return this.findParentModal(element.parentElement);
    }
}
